import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React, { Component } from 'react';
import styled from 'styled-components';
import { _js } from '@ifixit/localize';
var Body = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   margin-bottom: 24px;\n   font-size: 14px;\n   font-weight: normal;\n   line-height: 24px;\n"])));
var SeeMore = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   margin-bottom: 18px;\n   cursor: pointer;\n   font-size: 13px;\n"])));

var ReviewBody = /*#__PURE__*/function (_Component) {
  _inherits(ReviewBody, _Component);

  var _super = _createSuper(ReviewBody);

  function ReviewBody() {
    var _this;

    _classCallCheck(this, ReviewBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      expanded: false
    };

    _this.toggleExpanded = function () {
      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    };

    return _this;
  }

  _createClass(ReviewBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          body = _this$props.body,
          body_trunc = _this$props.body_trunc;
      var expanded = this.state.expanded;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Body, null, expanded ? body : "".concat(body_trunc).concat(body_trunc !== body ? '…' : '')), body_trunc && body !== body_trunc && /*#__PURE__*/React.createElement(SeeMore, {
        onClick: this.toggleExpanded
      }, expanded ? _js('See less') : !!body_trunc && _js('See more')));
    }
  }]);

  return ReviewBody;
}(Component);

export default ReviewBody;